import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router";
import { ReactSVG } from "react-svg";
import { toast } from "react-toastify";
import api from "../../../../../api/api";
import imgs from "../../../../../assets/images/imgs";
import MutipleFloatingChatBot from "../../../../../components/MutipleFloatingChatBot";
import Welcome from "../../../../../components/popup/student/Welcome";
import {
  JUST_LOGGED_IN_KEY,
  useAuth,
} from "../../../../../features/auth/AuthContext";
import { updateGlobalState } from "../../../../../state/global/slice";
import "../../../styles/dashboard.css";
import "../../../styles/r-style.css";
import StudentPopupSection from "../student/StudentDashboard_popup";
import SubjectOnlyPopup from "./subjects/SubjectOnlyPopup";
import StudentDashboardChatbot from "./chatbot/StudentChatbot";
import MyCourses from "./tabs/MyCourse";
import MyTeacher from "./tabs/MyTeacher";
import StudentHome from "./tabs/StudentHome";
import MarketPlace from "./course/MarketPlace";
import { briefcase } from "../../../../../assets/images/images";
import { changeScrollPopup } from "../../../../../utils/utlis";
import OverallPerformanceDashboard from "../../../../../components/OverallPerformanceDashboard/OverallPerformanceDashboard";
import FloatingAIButton from "../../../../../components/FloatingAIButton/FloatingAIButton";
import {
  setDrawerState,
  setIsWebAllowed,
  setQueryMetaData,
} from "../../../../../state/reducers/chatDrawerReducers";
import ProschoolStudentHome from "./tabs/ProschoolStudentHome";
import SRDSStudentHome from "./tabs/SRDSStudentHome";
import { cartList } from "../../../../../state/actions/cartlistAction";
import Loader from "../../../../../components/FileRepo/Components/Loader";
import MobileSidebarDrawer from "../../../../../components/Sidebar/MobileSidebarDrawer";
import { TABLET_DRAWER_BREAKPOINT } from "../../../../../context/SidebarDrawerContext";
import StudentSidebarNav from "./StudentSidebarNav";
import Meetings from "../../../../../components/BookAMeeting/Meetings";

const StudentDashboard = () => {
  const { token } = useAuth();
  const dispatch = useDispatch();
  const globalState = useSelector((state) => state.globalState);
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);
  const updateState = (key, value) => {
    dispatch(updateGlobalState({ key: key, value: value }));
  };
  const profileName =
    globalState?.role === "Student"
      ? (globalState?.student_details?.data?.name ?? globalState?.role)
      : (globalState?.teacher_details?.data?.name ?? globalState?.role);
  const isMarketplace = globalState.enabled_modules?.includes("marketplace");
  const isGoogleMeet = globalState.enabled_modules?.includes("google_meet");
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 1024);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const tabList = [
    {
      key: "Dashboard",
      route: "home",
      value: imgs.svg.dashboard_sidebar,
      activeValue: imgs.svg.dashboardactiveicon,
    },
    {
      key: "My Courses",
      route: "my-courses",
      value: imgs.svg.book,
      activeValue: imgs.svg.book_active,
    },
    {
      key: "Analytics",
      route: "analytics",
      value: imgs.svg.disable_icon,
      activeValue: imgs.svg.analyticsactive,
    },
    // { key: "My Teacher", route: "my-teacher", value: imgs.svg.sms_sidebar },  // hidden after AI Assistant
    ...(isMarketplace
      ? [
          {
            key: "Suggested Courses",
            route: "market-place",
            value: briefcase,
            activeValue: imgs.svg.suggestedactive,
          },
        ]
      : []),
    ...(isMobile && isGoogleMeet
      ? [
          {
            key: "Meetings",
            route: "meetings",
            value: imgs.svg.calendar,
            activeValue: imgs.svg.calendar,
          },
        ]
      : []),
  ];
  const navigate = useNavigate();
  const location = useLocation();
  const pathParts = location.pathname.split("/");
  const lastPathPart = pathParts[2];
  const getActiveTabState = lastPathPart.length
    ? tabList.find((tab) => tab.route == lastPathPart)?.key || null
    : tabList[0].key;
  const [activeTab, setActiveTab] = useState(getActiveTabState);
  const [teacherChat, setTeacherChat] = useState(null);
  const [getTeacherActiveChat, setTeacherActiveChat] = useState([]);
  const [chatbotTeacherStatus, setTeacherchatbotStatus] = useState(false);
  const [newStudFirstRender, setNewStudFirstRender] = useState(false);   // flag to store if the user is new proschool student to show the animation of the AI generated courses

  const redirectPath = localStorage.getItem("redirectAfterSignup");
  const redirectToCourse = localStorage.getItem("redirectToCourse");

  const [activeTeacher, setActiveTeacher] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isProfileCreated, setIsProfileCreated] = useState(() => {
    try {
      return Boolean(JSON.parse(localStorage.getItem("is_profile") || "false"));
    } catch {
      return false;
    }
  });

  useEffect(() => {
    const currentActiveTab = lastPathPart.length
      ? tabList.find((tab) => tab.route === lastPathPart)?.key || null
      : tabList[0].key;
    if (currentActiveTab !== activeTab) {
      setActiveTab(currentActiveTab);
    }
  }, [location.pathname, lastPathPart, tabList, activeTab]);

  const handleTeacherClick = (teacher) => {
    if (teacher !== activeTeacher) {
      setActiveTeacher(teacher);
    }
  };

  const updateTeacherActiveChat = (teacher) => {
    // Check if the teacher is already in the array
    const teacherExists = getTeacherActiveChat.some(
      (t) => t.name === teacher.name,
    );

    if (!teacherExists) {
      // If the teacher is not in the array, add them
      const newTeacherActiveChat = [...getTeacherActiveChat, teacher];

      // Limit the array to a maximum length of 3
      if (newTeacherActiveChat.length > 3) {
        newTeacherActiveChat.shift();
      }

      // Update the state with the new array to trigger re-render
      setTeacherActiveChat(newTeacherActiveChat);
    }
  };

  const removeTeacherActiveChat = (teacher) => {
    const newTeacherActiveChat = [...getTeacherActiveChat];
    const teacherIndex = newTeacherActiveChat.indexOf(teacher);

    if (teacherIndex !== -1) {
      newTeacherActiveChat.splice(teacherIndex, 1);
    }
    if (getTeacherActiveChat.length === 1) {
      setTeacherchatbotStatus(false);
    }

    setTeacherActiveChat(newTeacherActiveChat);
  };

  const onClickTeacher = (teacher) => {
    // Check if the teacher is already active

    const isTeacherActive = getTeacherActiveChat.some(
      (activeTeacher) => activeTeacher.name === teacher.name,
    );

    if (!isTeacherActive) {
      updateTeacherActiveChat({ ...teacher, isMinimized: false });
    }
    handleTeacherClick(teacher);
    setTeacherChat(teacher);
    setTeacherchatbotStatus(true);

    // Rest of your logic here
    const course_id = teacher.first_course?.[0]?.course_id || null;
    if (course_id !== null) {
      toast.error("This teacher never created any course.", {
        position: "top-center",
      });
      return;
    }
  };
  const onClickCourse = (teacher) => {
    updateTeacherActiveChat(teacher);
    const course_id =
      teacherChat?.first_course[0]?.course_id !== null
        ? (teacherChat?.first_course[0]?.course_id ?? null)
        : null;
    if (course_id !== null) {
      toast.error("This teacher never created any course.", {
        position: "top-center",
      });
      return;
    }
    setTeacherchatbotStatus(false);
    setTeacherChat(teacher);
  };
  const [showTooltip, setShowTooltip] = useState(false);
  const [WelcomePopupStatus, setWelcomePopupStatus] = useState(
    globalState?.has_profile || false,
  );
  const [ProfilePopupStatus, setProfilePopupStatus] = useState(false);
  // Existing profile that is missing subjects → show the subject-only popup.
  const [subjectPopupStatus, setSubjectPopupStatus] = useState(false);
  // Captured once on mount: true only when the dashboard is reached straight
  // from a fresh login, so reloads / returning sessions don't show the popup.
  const [cameFromLogin] = useState(() => {
    try {
      return sessionStorage.getItem(JUST_LOGGED_IN_KEY) === "true";
    } catch {
      return false;
    }
  });
  const canAddSubjects =
    globalState?.enabled_modules?.includes("allow_add_subjects") ?? false;
 const getProfileDetails = async () => {
  api
    .get("/students/get-student/", {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Token ${token}`,
      },
    })
    .then((response) => {
      if (response.data.status === 200) {
        if (response?.data?.data?.currency_symbol) {
          updateState("currency_symbol", response?.data?.data?.currency_symbol);
        }

        updateState("student_details", response?.data ?? {});
        setWelcomePopupStatus(true);
        setTimeout(() => {
          setWelcomePopupStatus(false);
          updateState("has_profile", true);
        }, 5000);
        setProfilePopupStatus(false);
        setIsProfileCreated(true);
        localStorage.setItem("is_profile", "true");

        // The API has used both `subject` and `subjects` for this field.
        const savedSubjects = Object.values(
          response?.data?.data?.subjects ??
            response?.data?.data?.subjects ??
            {},
        );
        // Module check happens at render time: enabled_modules is fetched
        // async by login() and may land after this response.
        setSubjectPopupStatus(cameFromLogin && savedSubjects.length === 0);
        // Consume the login flag so it only applies to this one visit.
        try {
          sessionStorage.removeItem(JUST_LOGGED_IN_KEY);
        } catch {}
        api
          .get("/auth/get-teacher-list/", {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Token ${token}`,
            },
          })
          .then((response) => {
            if (response.data.status === 200) {
              updateState("get_teacher_list", response?.data ?? {});
            }
          })
          .catch((error) => {});
        if (redirectPath !== null && redirectPath !== "") {
          navigate(redirectPath);
          localStorage.removeItem("redirectAfterSignup");
        }
        if (redirectToCourse !== null && redirectToCourse !== "") {
          navigate(redirectToCourse);
          localStorage.removeItem("redirectToCourse");
        }
      } else {
        setWelcomePopupStatus(false);
        setProfilePopupStatus(true);
      }
    })
    .catch((error) => {
      setWelcomePopupStatus(false);
      setProfilePopupStatus(true);

      if (error?.response?.status === 502) {
        toast.error("Something went wrong, please try again later.", {
          position: "top-center",
        });
      }
    });
};

  useEffect(() => {
    getProfileDetails();
    dispatch(cartList(token));
    if (isMarketplace) {
      setLoading(true)
      api
        .post(
          `courses/student/my-courses-dashboard/v2/?page=1`,
          {},
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Token ${token}`,
            },
          },
        )
        .then((response) => {
          if (response.status === 200) {
            updateState("student_courses", response?.data?.data ?? []);
          }
        })
        .catch((error) => {
         console.log('falsed to fetch courses', error)
        })
        .finally(() => {
          setLoading(false)
        })
    } else {
      setLoading(true)
      api
        .get("/courses/student/my-courses-dashboard/", {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Token ${token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            updateState("student_courses", response?.data?.data ?? []);
          }
        })
        .catch((error) => {
          console.log('Failed to fetch courses', error)
        })
        .finally(() => {setLoading(false)})
    }
  }, [token]);

  useEffect(() => {
    AOS.init({
      duration: 500,
    });
  }, []);

  const myCoursesCount = globalState?.my_courses_length;
  useEffect(() => {
    if (WelcomePopupStatus === true) {
      changeScrollPopup("hidden", "welcome-polly-popup-wrapper");
    } else {
      changeScrollPopup("auto", "welcome-polly-popup-wrapper");
    }
  }, [WelcomePopupStatus]);

  return (
    <>
      {WelcomePopupStatus === true && !(globalState?.has_profile === true) && (
        <Welcome
          setWelcomePopupStatus={setWelcomePopupStatus}
          setShowTooltip={setShowTooltip}
        />
      )}
      {/* {ProfilePopupStatus === true && ( */}
      {/* Onboarding takes precedence; the subject popup is only for existing
          profiles, so the two never stack. */}
      {!isProfileCreated ? (
        <StudentPopupSection
          setLoader={setLoading}
          ProfilePopupStatus={ProfilePopupStatus}
          setProfilePopupStatus={setProfilePopupStatus}
          setWelcomePopupStatus={setWelcomePopupStatus}
          setShowTooltip={setShowTooltip}
          setNewStudFirstRender = {setNewStudFirstRender}
          isMarketplace={isMarketplace}
          setIsProfileCreated={setIsProfileCreated}
        />
      ) : (
        subjectPopupStatus && canAddSubjects && (
          <SubjectOnlyPopup onClose={() => setSubjectPopupStatus(false)} />
        )
      )}
      <div className="dashboard">
        <div className="studentDashboardbody">
          <StudentSidebarNav
            tabList={tabList}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
          {/* Same tabs, opened from the header hamburger on mobile and tablet */}
          <MobileSidebarDrawer breakpoint={TABLET_DRAWER_BREAKPOINT}>
            <StudentSidebarNav
              tabList={tabList}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
          </MobileSidebarDrawer>
          <div className="studentDashboardMainBody">
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard/home" />} />
              <Route
                path="home"
                element={
                <>
                    {isMarketplace ? (<>
                      {loading ? <Loader /> :
                      <ProschoolStudentHome
                        showTooltip={showTooltip}
                        teacherChat={teacherChat}
                        setTeacherChat={setTeacherChat}
                        setShowTooltip={setShowTooltip}
                        profileFirstName={profileName}
                        chatbotTeacherStatus={chatbotTeacherStatus}
                        setTeacherchatbotStatus={setTeacherchatbotStatus}
                        getTeacherActiveChat={getTeacherActiveChat}
                        setTeacherActiveChat={setTeacherActiveChat}
                        onClickTeacher={onClickTeacher}
                        activeTeacher={activeTeacher}
                        handleTeacherClick={handleTeacherClick}
                        removeTeacherActiveChat={removeTeacherActiveChat}
                        setActiveTab={setActiveTab}
                        newStudFirstRender = {newStudFirstRender}
                        loader = {loading}
                      />}
                   </> ) : (
                      <SRDSStudentHome
                        showTooltip={showTooltip}
                        teacherChat={teacherChat}
                        setTeacherChat={setTeacherChat}
                        setShowTooltip={setShowTooltip}
                        profileFirstName={profileName}
                        chatbotTeacherStatus={chatbotTeacherStatus}
                        setTeacherchatbotStatus={setTeacherchatbotStatus}
                        getTeacherActiveChat={getTeacherActiveChat}
                        setTeacherActiveChat={setTeacherActiveChat}
                        onClickTeacher={onClickTeacher}
                        activeTeacher={activeTeacher}
                        handleTeacherClick={handleTeacherClick}
                        removeTeacherActiveChat={removeTeacherActiveChat}
                        setActiveTab={setActiveTab}
                      />
                    )}
                    {/* <StudentHome
                      showTooltip={showTooltip}
                      teacherChat={teacherChat}
                      setTeacherChat={setTeacherChat}
                      setShowTooltip={setShowTooltip}
                      profileFirstName={profileName}
                      chatbotTeacherStatus={chatbotTeacherStatus}
                      setTeacherchatbotStatus={setTeacherchatbotStatus}
                      getTeacherActiveChat={getTeacherActiveChat}
                      setTeacherActiveChat={setTeacherActiveChat}
                      onClickTeacher={onClickTeacher}
                      activeTeacher={activeTeacher}
                      handleTeacherClick={handleTeacherClick}
                      removeTeacherActiveChat={removeTeacherActiveChat}
                      setActiveTab={setActiveTab}
                    /> */}
                    {!ProfilePopupStatus && (
                      <FloatingAIButton
                        onClick={() => {
                          dispatch(setDrawerState(!chatDrawerState.isOpen));
                          dispatch(setIsWebAllowed(true));
                          dispatch(setQueryMetaData(null));
                        }}
                      />
                    )}
                  </>
                }
              />
              <Route
                path="my-courses/*"
                element={
                  <>
                    <MyCourses
                      setShowTooltip={setShowTooltip}
                      profileFirstName={profileName}
                      chatbotTeacherStatus={chatbotTeacherStatus}
                      setTeacherchatbotStatus={setTeacherchatbotStatus}
                      getTeacherActiveChat={getTeacherActiveChat}
                      onClickCourse={onClickCourse}
                      setTeacherActiveChat={setTeacherActiveChat}
                      onClickTeacher={onClickTeacher}
                      removeTeacherActiveChat={removeTeacherActiveChat}
                    />
                    <FloatingAIButton
                      onClick={() => {
                        dispatch(setDrawerState(!chatDrawerState.isOpen));
                        dispatch(setIsWebAllowed(true));
                        dispatch(setQueryMetaData(null));
                      }}
                    />
                  </>
                }
              />
              <Route path="my-teacher" element={<MyTeacher />} />
              <Route
                path="analytics"
                element={
                  <>
                    <OverallPerformanceDashboard />
                    <FloatingAIButton
                      onClick={() => {
                        dispatch(setDrawerState(!chatDrawerState.isOpen));
                        dispatch(setIsWebAllowed(true));
                        dispatch(setQueryMetaData(null));
                      }}
                    />
                  </>
                }
              />
              {isMarketplace && (
                <Route path="market-place" element={<MarketPlace />} />
              )}
              <Route path="meetings" element={<Meetings />} />
            </Routes>
          </div>
        </div>

        <div className="StudentChatbot-section">
          <div
            className={
              getTeacherActiveChat.length > 0
                ? "studentDashboard-chatbot-wrapper"
                : ""
            }
          >
            {getTeacherActiveChat.map((teacher, index) => (
              <div key={index}>
                {chatbotTeacherStatus && (
                  <StudentDashboardChatbot
                    key={index}
                    removeTeacherActiveChat={() =>
                      removeTeacherActiveChat(teacher)
                    }
                    right={index * 30}
                    ai_name={`${teacher.ai_name}`}
                    teacher_id={teacher?.user}
                    courseId={
                      teacher?.first_course
                        ? (teacher?.first_course?.course_id ?? "")
                        : ""
                    }
                    isMinimize={teacher.isMinimized}
                    chatbotStatus={chatbotTeacherStatus}
                    lesson_name={
                      teacher?.first_lesson
                        ? (teacher?.first_lesson?.lesson_name ?? "")
                        : ""
                    }
                    ai_tone={teacher?.ai_tone}
                    ai_avatar={teacher?.ai_avatar}
                    ai_welcome_msg={teacher?.ai_welcome_msg}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <MutipleFloatingChatBot
        teacherChat={teacherChat}
        onClickTeacher={onClickTeacher}
        getTeacherActiveChat={getTeacherActiveChat}
      />
    </>
  );
};

export default StudentDashboard;